export const POINT_COLOR = 'rgba(81,14,234,1)';
export const GRAY_COLOR = '#F0F0F0';